import { render, staticRenderFns } from "./informationAdmin.vue?vue&type=template&id=33564dc7&scoped=true&"
import script from "./informationAdmin.vue?vue&type=script&lang=js&"
export * from "./informationAdmin.vue?vue&type=script&lang=js&"
import style0 from "./informationAdmin.vue?vue&type=style&index=0&id=33564dc7&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33564dc7",
  null
  
)

export default component.exports